const productMeta = [
  {
    target: 'tomato',
    image: '/assets/tomato-cutout.png',
    nutrition: true,
  },
  {
    target: 'ajika',
    image: '/assets/ajika-cutout.png',
    nutrition: true,
  },
  {
    target: 'horseradish',
    image: '/assets/horseradish-cutout.png',
    nutrition: true,
  },
  {
    target: 'ketchup',
    image: '/assets/ketchup-cutout.png',
    nutrition: true,
  },
  {
    target: 'vinegar',
    image: '/assets/vinegar-cutout.png',
    nutrition: false,
  },
  {
    target: 'vinegar-apple',
    image: '/assets/apple_vinegar-cutout.png',
    nutrition: false,
  },
];

const productTranslations = {
  ru: {
    tomato: {
      name: 'Томатная паста',
      weights: '270 г / 500 г / 1 л / 3.2 л',
      shelfLife: '2 года',
      composition: 'томатная паста, вода питьевая, соль поваренная, сахар.',
      description:
        'Томатная паста изготавливается без добавления овощных и фруктовых пюре, красителей и ароматизаторов. У нее насыщенный вкус, цвет и аромат натурального концентрированного томатного сырья.',
      nutrition: { proteins: '5 г', carbs: '20 г' },
      accent: 'Насыщенная база для соусов, супов и горячих блюд.',
    },
    ajika: {
      name: 'Аджика',
      weights: '270 г',
      shelfLife: '2 года',
      composition:
        'вода, перец красный, чеснок, укроп, хмели-сунели, кориандр, соль, уксус.',
      description:
        'Аджика - теплый огонь семейного застолья. Она подходит к мясу, птице, рыбе и овощам, а также раскрывается как ингредиент для домашних соусов.',
      nutrition: { proteins: '0.9 г', carbs: '4.6 г' },
      accent: 'Пряный характер для маринадов и мясных блюд.',
    },
    horseradish: {
      name: 'Горчица',
      weights: '250 г',
      shelfLife: '6 месяцев',
      composition:
        'вода, горчичный порошок, сахар, соль, перец черный, масло растительное, лавровый лист, уксус.',
      description:
        'Горчица приготовлена по традиционным русским рецептам с применением современных технологий производства. Острый вкус остается чистым и узнаваемым.',
      nutrition: { proteins: '11 г', carbs: '4 г' },
      accent: 'Классическая острота для русской кухни.',
    },
    ketchup: {
      name: 'Кетчуп',
      weights: '750 г',
      shelfLife: '6 месяцев',
      composition:
        'вода, томатная паста, крахмал, уксус, соль, сахар, паприка сладкая, перец красный, специи.',
      description:
        'Кетчуп дополняет привычные домашние блюда: пельмени, мясо, пироги, шашлык и заготовки. Вкус сбалансирован томатной основой и мягкими специями.',
      nutrition: { proteins: '0,85 г', carbs: '15,7 г' },
      accent: 'Томатный вкус для ежедневной кухни.',
    },
    vinegar: {
      name: 'Уксус',
      weights: '500 г',
      shelfLife: '12 месяцев',
      composition:
        'уксус из пищевого сырья спиртовой «Столовый», концентрация уксусной кислоты 9%.',
      description:
        'Столовый уксус - базовый продукт для маринадов, консервации и повседневной кухни. Стабильная концентрация помогает получать предсказуемый результат.',
      nutrition: null,
      accent: 'Надежная основа для домашних заготовок.',
    },
    'vinegar-apple': {
      name: 'Уксус яблочный',
      weights: '500 г',
      shelfLife: '12 месяцев',
      composition:
        'уксус яблочный из пищевого сырья, концентрация яблочной кислоты 6%.',
      description:
        'Яблочный уксус имеет насыщенный вкус и аромат, подходит для маринадов, салатов, соусов и повседневного использования.',
      nutrition: null,
      accent: 'Мягкая кислинка для салатов и соусов.',
    },
  },
  en: {
    tomato: {
      name: 'Tomato Paste',
      weights: '270 g / 500 g / 1 l / 3.2 l',
      shelfLife: '2 years',
      composition: 'tomato paste, drinking water, table salt, sugar.',
      description:
        'Tomato paste is made without vegetable or fruit purees, colorants, or flavorings. It has a rich taste, color, and aroma of natural concentrated tomato raw material.',
      nutrition: { proteins: '5 g', carbs: '20 g' },
      accent: 'A rich base for sauces, soups, and hot dishes.',
    },
    ajika: {
      name: 'Adjika',
      weights: '270 g',
      shelfLife: '2 years',
      composition:
        'water, red pepper, garlic, dill, khmeli-suneli, coriander, salt, vinegar.',
      description:
        'Adjika brings warm spice to the family table. It pairs with meat, poultry, fish, and vegetables, and works well as an ingredient for homemade sauces.',
      nutrition: { proteins: '0.9 g', carbs: '4.6 g' },
      accent: 'A spicy character for marinades and meat dishes.',
    },
    horseradish: {
      name: 'Mustard',
      weights: '250 g',
      shelfLife: '6 months',
      composition:
        'water, mustard powder, sugar, salt, black pepper, vegetable oil, bay leaf, vinegar.',
      description:
        'Mustard is prepared according to traditional Russian recipes using modern production technologies. The sharp taste stays clean and recognizable.',
      nutrition: { proteins: '11 g', carbs: '4 g' },
      accent: 'Classic heat for familiar kitchen staples.',
    },
    ketchup: {
      name: 'Ketchup',
      weights: '750 g',
      shelfLife: '6 months',
      composition:
        'water, tomato paste, starch, vinegar, salt, sugar, sweet paprika, red pepper, spices.',
      description:
        'Ketchup complements everyday dishes: dumplings, meat, pies, barbecue, and preserves. The taste is balanced by a tomato base and mild spices.',
      nutrition: { proteins: '0.85 g', carbs: '15.7 g' },
      accent: 'Tomato flavor for everyday cooking.',
    },
    vinegar: {
      name: 'Vinegar',
      weights: '500 g',
      shelfLife: '12 months',
      composition:
        'table vinegar from food-grade alcohol raw material, acetic acid concentration 9%.',
      description:
        'Table vinegar is a basic product for marinades, preserving, and everyday cooking. A stable concentration helps deliver predictable results.',
      nutrition: null,
      accent: 'A reliable base for homemade preserves.',
    },
    'vinegar-apple': {
      name: 'Apple Vinegar',
      weights: '500 g',
      shelfLife: '12 months',
      composition:
        'apple vinegar from food raw material, malic acid concentration 6%.',
      description:
        'Apple vinegar has a full taste and aroma. It is suitable for marinades, salads, sauces, and everyday use.',
      nutrition: null,
      accent: 'A soft acidity for salads and sauces.',
    },
  },
  kk: {
    tomato: {
      name: 'Томат пастасы',
      weights: '270 г / 500 г / 1 л / 3.2 л',
      shelfLife: '2 жыл',
      composition: 'томат пастасы, ауыз су, ас тұзы, қант.',
      description:
        'Томат пастасы көкөніс және жеміс езбесін, бояғыштар мен хош иістендіргіштерді қоспай дайындалады. Дәмі, түсі және табиғи қоюлатылған томат шикізатының хош иісі қанық.',
      nutrition: { proteins: '5 г', carbs: '20 г' },
      accent: 'Тұздықтар, сорпалар және ыстық тағамдар үшін қанық негіз.',
    },
    ajika: {
      name: 'Аджика',
      weights: '270 г',
      shelfLife: '2 жыл',
      composition:
        'су, қызыл бұрыш, сарымсақ, аскөк, хмели-сунели, кориандр, тұз, сірке суы.',
      description:
        'Аджика отбасылық дастарханға жылы ащылық қосады. Етке, құс етіне, балыққа және көкөніске жарайды, үй тұздықтарына ингредиент ретінде де ашылады.',
      nutrition: { proteins: '0.9 г', carbs: '4.6 г' },
      accent: 'Маринадтар мен ет тағамдарына арналған дәмді ащылық.',
    },
    horseradish: {
      name: 'Қыша',
      weights: '250 г',
      shelfLife: '6 ай',
      composition:
        'су, қыша ұнтағы, қант, тұз, қара бұрыш, өсімдік майы, лавр жапырағы, сірке суы.',
      description:
        'Қыша дәстүрлі рецептура бойынша заманауи өндіріс технологиясымен дайындалады. Оның ащы дәмі таза әрі таныс болып қалады.',
      nutrition: { proteins: '11 г', carbs: '4 г' },
      accent: 'Күнделікті ас үйге арналған классикалық ащылық.',
    },
    ketchup: {
      name: 'Кетчуп',
      weights: '750 г',
      shelfLife: '6 ай',
      composition:
        'су, томат пастасы, крахмал, сірке суы, тұз, қант, тәтті паприка, қызыл бұрыш, дәмдеуіштер.',
      description:
        'Кетчуп күнделікті тағамдарды толықтырады: тұшпара, ет, бәліш, кәуап және қысқы дайындықтар. Дәмі томат негізі мен жұмсақ дәмдеуіштер арқылы теңгерілген.',
      nutrition: { proteins: '0,85 г', carbs: '15,7 г' },
      accent: 'Күнделікті ас үйге арналған томат дәмі.',
    },
    vinegar: {
      name: 'Сірке суы',
      weights: '500 г',
      shelfLife: '12 ай',
      composition:
        'тағамдық спирт шикізатынан жасалған асханалық сірке суы, сірке қышқылының концентрациясы 9%.',
      description:
        'Асханалық сірке суы маринадтар, консервілеу және күнделікті ас үй үшін негізгі өнім. Тұрақты концентрация болжамды нәтиже береді.',
      nutrition: null,
      accent: 'Үйдегі қысқы дайындықтарға арналған сенімді негіз.',
    },
    'vinegar-apple': {
      name: 'Алма сірке суы',
      weights: '500 г',
      shelfLife: '12 ай',
      composition:
        'тағамдық шикізаттан жасалған алма сірке суы, алма қышқылының концентрациясы 6%.',
      description:
        'Алма сірке суының дәмі мен хош иісі қанық. Маринадтарға, салаттарға, тұздықтарға және күнделікті қолдануға жарайды.',
      nutrition: null,
      accent: 'Салаттар мен тұздықтарға арналған жұмсақ қышқылдық.',
    },
  },
};

const categoryTranslations = {
  ru: [
    {
      title: 'Томатные продукты',
      text: 'Паста и кетчуп для соусов, горячих блюд и ежедневной кухни.',
      target: 'tomato',
      productTargets: ['tomato', 'ketchup'],
    },
    {
      title: 'Острые приправы',
      text: 'Аджика и горчица для мяса, маринадов и яркого вкуса.',
      target: 'ajika',
      productTargets: ['ajika', 'horseradish'],
    },
    {
      title: 'Уксусы',
      text: 'Столовый и яблочный уксус для консервации, салатов и заготовок.',
      target: 'vinegar',
      productTargets: ['vinegar', 'vinegar-apple'],
    },
  ],
  en: [
    {
      title: 'Tomato Products',
      text: 'Paste and ketchup for sauces, hot dishes, and everyday cooking.',
      target: 'tomato',
      productTargets: ['tomato', 'ketchup'],
    },
    {
      title: 'Spicy Condiments',
      text: 'Adjika and mustard for meat, marinades, and a brighter taste.',
      target: 'ajika',
      productTargets: ['ajika', 'horseradish'],
    },
    {
      title: 'Vinegars',
      text: 'Table and apple vinegar for preserves, salads, and preparations.',
      target: 'vinegar',
      productTargets: ['vinegar', 'vinegar-apple'],
    },
  ],
  kk: [
    {
      title: 'Томат өнімдері',
      text: 'Тұздықтарға, ыстық тағамдарға және күнделікті ас үйге арналған паста мен кетчуп.',
      target: 'tomato',
      productTargets: ['tomato', 'ketchup'],
    },
    {
      title: 'Ащы дәмдеуіштер',
      text: 'Етке, маринадтарға және жарқын дәмге арналған аджика мен қыша.',
      target: 'ajika',
      productTargets: ['ajika', 'horseradish'],
    },
    {
      title: 'Сірке сулары',
      text: 'Консервілеу, салаттар және дайындықтарға арналған асханалық және алма сірке суы.',
      target: 'vinegar',
      productTargets: ['vinegar', 'vinegar-apple'],
    },
  ],
};

function resolveLanguage(language) {
  return productTranslations[language] ? language : 'ru';
}

export function getProducts(language = 'ru') {
  const activeLanguage = resolveLanguage(language);
  const dictionary = productTranslations[activeLanguage];

  return productMeta.map((item) => ({
    ...item,
    ...dictionary[item.target],
    image: item.image,
  }));
}

export function getProductCategories(language = 'ru') {
  const activeLanguage = resolveLanguage(language);
  return categoryTranslations[activeLanguage];
}

export const products = getProducts('ru');
export const productCategories = getProductCategories('ru');
